import { Button } from "melco-ui";
import { useTranslation } from "react-i18next";



type UserDetailProfileButtonProps = {

  setIsEditProfileDrawerOpenAction: (v: boolean) => void
};

export const UserEditProfileButton: React.FC<
  UserDetailProfileButtonProps
> = ({ setIsEditProfileDrawerOpenAction }) => {

  const { t } = useTranslation();
  return (
    <>
      {
        <Button
          key="user-edit-profile"
          type="primary"
          onClick={async () => {

            setIsEditProfileDrawerOpenAction(true);
          }}

        >
          {t("users.profileupdate.button")}
        </Button>
      }
    </>


  );
};
